import { render } from "./accessDetail.vue?vue&type=template&id=d1c48936&scoped=true&ts=true"
import script from "./accessDetail.vue?vue&type=script&lang=ts&config=true"
export * from "./accessDetail.vue?vue&type=script&lang=ts&config=true"

import "./accessDetail.vue?vue&type=style&index=0&id=d1c48936&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1c48936"]])

export default __exports__